import UpgradeCard from "../subscription/UpgradeCard";
import ManagePlanActionsCard from "../manage-plan/ManagePlanActionsCard";


export default function ManagePlanTab() {
  return (
    <div className="flex flex-col gap-8 pb-8">
      <UpgradeCard/>
      <ManagePlanActionsCard />
    </div>
  );
}
